import useCatalogFilters from 'composables/useCatalogFilters';
import useFilters from 'composables/useFilters';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component({
  props: {
    facet: {
      type: Object,
    },
    isBoxCatalog: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const filterStore = props.isBoxCatalog ? useCatalogFilters() : useFilters();
    const { getCurrentFilters, getCardSelected, handleChangeFilters } =
      filterStore;

    // No me vengan a buscar por esto por favor, entiendan que lo querían para hoy mismo
    // y esto es imposible de debuggear
    if (
      props.facet.name === 'category_name' &&
      props.facet.results.length === 1 &&
      getCurrentFilters.value[getCardSelected.value][props.facet.name]
        .length === 0
    ) {
      setTimeout(() => {
        getCurrentFilters.value[getCardSelected.value][props.facet.name] =
          props.facet.results[0].value;
        handleChangeFilters(props.facet.name, props.facet.input_type);
      });
    }

    return {
      currentFilter: getCurrentFilters,
      cardSelected: getCardSelected,
      onChange: handleChangeFilters,
    };
  },
})
export default class FacetComponent extends Vue {
  openAcordion = false;
  isMobile = window.innerWidth <= 768;

  mounted() {
    this.openAcordion = !this.isMobile;
  }

  acordion() {
    this.openAcordion = !this.openAcordion;
  }

  @Watch('currentFilter', { immediate: true })
  onCurrentFilterChange() {
    // No me vengan a buscar por esto por favor, entiendan que lo querían para hoy mismo
    // y esto es imposible de debuggear
    if (
      this.facet.name === 'category_name' &&
      this.facet.results.length === 1 &&
      this.currentFilter[this.cardSelected][this.facet.name].length === 0
    ) {
      setTimeout(() => {
        this.currentFilter[this.cardSelected][this.facet.name] =
          this.facet.results[0].value;
        this.onChange(this.facet.name, this.facet.input_type);
      });
    }
  }
}
